module.exports = __webpack_public_path__ + "img/4.ffbc9b52.png";